<template>
  <div class="brandBox">
    <div class="brandHead">
      <input class="ipt" placeholder="搜索专柜名称或关键词" v-model="barandNa"  />
      <!--<md-field>-->
        <!--<md-field-item title="所在门店" :content="selectorValue" @click="showSelector" arrow solid />-->
      <!--</md-field>-->
      <div class="tabBox">
        <div :class="['tabItem',{'borderColor':tabState==1}]" @click="clickActive(1)">
          楼层
          <div :class="['iconBox',{'rotate180':tabState==1}]">
            <i :class="['iconfont','iconxiajiantou']"></i>
          </div>
        </div>
        <div :class="['tabItem',{'borderColor':tabState==2}]" @click="clickActive(2)">
          品类
          <div :class="['iconBox',{'rotate180':tabState==2}]">
            <i :class="['iconfont','iconxiajiantou']"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="scrollBox">
      <div class="scrollBoxContent">
        <div class="itemV" v-for="(item, index) in goodsList" :key="index" @click="gotoBrand(item)">
          <div class="imgBox">
            <!--/manager/fileserver-->
            <img :src="'/manager/fileserver/file/download?id='+item.logoUrl" class="imgStyle" />
          </div>

          <div class="itemContV">
            <div class="itemContVtitle">{{item.brandNa}}</div>
            <div class="itemContVmain">
                <i class="iconfont icondingwei"></i>
                <span>{{item.floorId}} {{item.buslName}}</span>
            </div>
          </div>
          <i class="iconfont iconjiantou"></i>
        </div>
      </div>
    </div>

    <div class="zheZhao" v-if="state" @click.stop="closeFn">
      <div class="zheZaoContent" @click.stop="">
        <div class="zheZhaotabBox">
          <div :class="['tabItem',{'borderColor':tabState==1}]" @click="clickActive(1)">
            楼层
            <div :class="['iconBox',{'rotate180':tabState==1}]">
              <i :class="['iconfont','iconxiajiantou']"></i>
            </div>
          </div>
          <div :class="['tabItem',{'borderColor':tabState==2}]" @click="clickActive(2)">
            品类
            <div :class="['iconBox',{'rotate180':tabState==2}]">
              <i :class="['iconfont','iconxiajiantou']"></i>
            </div>
          </div>
        </div>
        <div class="scrollH">
          <div class="scrollContent">
            <div class="zheZhaoMain" v-if="tabState==1">
              <div
                :class="['minItem',{'minItemActive':itemState==index}]"
                @click="pitchOnFloor(item,index)"
                v-for="(item, index) in newFloorArr"
                :key="index"
              >{{item.floorNo}} {{item.floorNa}}</div>
            </div>
            <div class="zheZhaoMain" v-else>
              <div
                :class="['minItem',{'minItemActive':itemState==index}]"
                @click="pitchOnFn(item,index)"
                v-for="(item, index) in newClassArr"
                :key="index"
              >{{item.clsNo}} {{item.clsNa}}</div>
            </div>
          </div>
        </div>
        <div class="mapBox">
          <img :src="'/manager/fileserver/file/download?id='+imgId" >
        </div>
      </div>
    </div>

    <!--<md-selector-->
      <!--v-model="isSelectorShow"-->
      <!--default-value="2"-->
      <!--:data="shopList"-->
      <!--max-height="320px"-->
      <!--title="请选择门店"-->
      <!--large-radius-->
      <!--@choose="onSelectorChoose"-->
    <!--&gt;</md-selector>-->
  </div>
</template>
<script>
export default {
  data() {
    return {
      // isSelectorShow: false, //选择列表状态
      // selectorValue: "请选择门店", //选择器内容
      // shopList: [
      //   //门店数据
      //   { value: "1", text: "选项" }
      // ],
      tabState: -1, //控制楼层区域按钮
      state: false, //控制遮罩显示
      shoreId: "", //门店id
      itemState: "",
      // floorList: [], //楼层
      // areaList: [], //区域
      goodsList: [], //商品列表
      storeId:'611', //分店门店id
      barandNa:'', //搜索名
      newFloorArr:[], //楼层
      newClassArr:[], //品类
      imIdx:0
    };
  },
  mounted() {
    document.title = "品牌";
    this.$http.post('/sangto-wrm/WxBrandShow/page').then(({data})=>{ //品牌列表数据
      this.goodsList = data.data.rows
    })

    this.$http.get('/sangto-wrm/homePage/floor/page').then(({data})=>{ //获取楼层
       let arr = data.data.rows
        arr.forEach(item => { //添加排序标
          item.rank = item.floorNo.slice(item.floorNo.indexOf('F')+1)
        })
        arr.sort((a, b) =>{ //排序
          return a.rank - b.rank
        })
      this.newFloorArr = arr
    })
    this.$http.get('/sangto-wrm/homePage/cls/page').then(({data}) =>{ //获取品类
      this.newClassArr = data.data.rows
    })

  },
  computed: {
    imgId(){ //获取地图
       return this.newFloorArr[this.imIdx].imgUrl
    }

  },
  methods: {
    // searchFn() {
    //   //搜索
    // },
    // showSelector() {
    //   //选择器改变状态
    //   this.isSelectorShow = true;
    // },
    // onSelectorChoose({ text, value }) {
    //   //获取选择器获取的内容
    // },
    clickActive(index) {
      //点击楼层区域按钮修改状态
      //   if(!this.shoreId){
      //       Toast.info('请选择门店')
      //       return
      //   }
      this.tabState = index;
      this.state = true;
    },
    closeFn() {
      //关闭遮罩
      this.state = false;
    },

    pitchOnFloor(item, index) {
      //获取楼层数据
      this.imIdx = index
      this.itemState = index;
      this.state = false;
      //这里掉接口获取数据
      // floorId: itemdata.propertyPlaceCode, 接口参数
      // shoreId: itemdata.storeId
      let td = new URLSearchParams()
      td.append('floorId', item.floorNo)
      // td.append('shoreId', this.storeId)
      this.$http.post('/sangto-wrm/WxBrandShow/page', td).then(({data})=>{ //品牌列表数据

        this.goodsList = data.data.rows
      })
    },
    pitchOnFn(item, index) {
      //获取区域数据
      this.itemState = index;
      this.state = false;
      //这里掉接口获取数据
      // buildingId: itemdata.propertyPlaceCode, 接口参数
      // shoreId: itemdata.storeId
      let td = new URLSearchParams()
      td.append('buslNo', item.clsNo)
      // td.append('shoreId', this.storeId)
      this.$http.post('/sangto-wrm/WxBrandShow/page', td).then(({data})=>{ //品牌列表数据

        this.goodsList = data.data.rows
      })
    },
    gotoBrand(item) {
      //选择品牌跳转到品牌详情页
      let data = JSON.stringify(item)
      this.$router.push({path:'/brandDetails',query:{itemData:data}})
    }
  },
  watch:{
    barandNa(val){
      let dt =new URLSearchParams()
      dt.append('brandNa', val)
      this.$http.post('/sangto-wrm/WxBrandShow/page', dt).then(({data})=>{ //品牌列表数据
        this.goodsList = data.data.rows
      })
    }
  }
};
</script>
<style lang="scss" scoped>
.brandBox {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  .itemContVmain{
    color: #888;
    font-size: 12px;
    margin-top: 8px;
  }
  .mapBox{
    margin: 10px auto 0 auto;
    width: 90%;
    height: 120px;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .imgBox{
    width: 80px;
    height: 70px;
    overflow: hidden;
    border: 1px solid #f1f1f1;
    border-radius: 4px;
    margin-left: 13px;
  }
  .brandHead {
    background: #fff;
    position: relative;
    width: 100%;
    /*height: 160px;*/
    height: 90px;
    display: flex;
    flex-direction: column;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.08);
    z-index: 100;
  }
  .ipt {
    border: none;
    outline: none;
    font-size: 14px;
    height: 30px;
    background-color: #f2f2f2;
    width: 90%;
    margin: 10px auto 0 auto;
    text-align: center;
    border-radius: 4px;
  }
  .tabBox {
    position: absolute;
    width: 70%;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
  }
  .iconBox {
    transition: transform 0.5s;
    margin-left: 4px;
  }
  .tabItem {
    flex: 1;
    font-size: 14px;
    text-align: center;
    height: 35px;
    display: flex;
    justify-content: center;
    line-height: 35px;
    border-bottom: 2px solid #fff;
  }
  .iconxiajiantou {
    font-size: 14px;
  }
  .rotate0 {
    transform: rotate(0);
  }
  .rotate180 {
    transform: rotate(180deg);
  }
  .borderColor {
    border-bottom-color: #6cf;
  }
  .zheZhao {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
  }
  .zheZaoContent {
    position: relative;
    top: 53px;
    width: 100%;
    height: 350px;
    background-color: #fff;

  }
  .icondingwei{
    position: relative;
    top: 1px;
    font-size: 12px;
  }
  .zheZhaotabBox {
    position: relative;
    top: 2px;
    width: 70%;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    z-index: 100;
  }
  .scrollH {
    height: 160px;
    overflow-x: hidden;
    overflow-y: auto;
  }
  .scrollContent {
    width: 100%;
  }
  .zheZhaoMain {
    margin: 13px auto 0 auto;
    width: 90%;
    padding-bottom: 20px;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    justify-content: space-between;
  }
  .minItem{
    font-size: 12px;
    width: 160px;
    height: 25px;
    line-height: 25px;
    text-align: center;
    color: #888;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    margin-top: 6px;
    border-radius: 3px;
    border: 1px solid #fff;
  }
  .minItemActive {
    border-color: #888;
  }

  .scrollBox {
    position: absolute;
    /*top: 163px;*/
    top: 90px;
    left: 0;
    right: 0;
    bottom: 0;
    background: #f5f5f5;
    overflow-x: hidden;
    overflow-y: auto;
  }
  .scrollBoxContent {
    width: 100%;
    padding-bottom: 10px;
  }
  .itemV {
    position: relative;
    margin: 9px auto 0 auto;
    width: 94%;
    height: 95px;
    background-color: #fff;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
  }
  .imgStyle {
    width: 100%;
    height: 100%;
  }
  .itemContV {
    margin-left: 12px;
    width: 170px;
    height: 55px;
    display: flex;
    flex-direction: column;
    /*justify-content: space-between;*/
  }
  .itemContVtitle{
    font-size: 16px;
    font-weight: 500;
    }
    .icondingwei{
    font-size: 16px;
    }
    .iconjiantou{
    position: absolute;
    right: 4px;
    font-size: 12px;
    top: 50%;
    transform: translateY(-60%);
    color: #888;
    }
}
</style>
